[
    {
        "question": "What are Different Sources where I can receive Quote/Proposals/Policy Document?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            " You can receive your Quote/Proposal/Policy Documents on your registered email id/SMS/ WhatsApp on registered mobilenumber."
        ]
    },
    {
        "question": "How can I accept the Proposal?",
        "is_answer_multiple": true,
        "is_answer_header": true,
        "answer_header": [
            "You can accept your proposal by accessing the Proposal link received on your email/WhatsApp/SMS.To accept the Proposal Please follow the steps given below:"
        ],
        "answer": [
            " Open the link received on Email/SMS/WhatsApp.",
            "You will be able to see the Proposal details.",
            "You will get options to accept the Proposal by simply clicking on Accept button.",
            "Once you click on Accept button, you will receive OTP on Email/SMS/WhatsApp.",
            "You will see option to Enter the OTP and Validate the same and give the consent to accept the Proposal."
        ]
    },
    {
        "question": "Can I Reject my Proposal?",
        "is_answer_multiple": true,
        "is_answer_header": true,
        "answer_header": [
            "Yes, you can Reject the Proposal if you have any concerns/Queries on Proposal received."
        ],
        "answer": [
            " Open the link received on Email/SMS/WhatsApp.",
            "You will be able to see the Proposal details.",
            "You will get options to Reject the Proposal by simply clicking on Reject button, optionally you can add the Rejection details.",
            "Once you click on Reject button, Proposal will be Rejected and same will be informed to Liberty Representative for any changes."
        ]
    },
    {
        "question": "Can I Edit non premium bearing information on web page?",
        "is_answer_multiple": true,
        "is_answer_header": true,
        "answer_header": [
            "Yes, you can Edit non premium bearing information on web page so that you can correct the proposal data.Follow the below Steps to do the same:"
        ],
        "answer": [
            " Click on web page link received for Proposal.",
            "Once Proposal Page is Opened, you will see Edit Button on Proposal Page",
            "By clicking on Edit Button you can edit the below information and Save it.1.Salutation 2.First Name 3.Middle Name 4.Last Name 5.Mobile Number6.Email ID 7.Alternate mail ID 8.Alternate Mobile Number 9.Mailing Address"
        ]
    },
    {
        "question": "Can I download product brochure from the web page?",
        "is_answer_multiple": true,
        "is_answer_header": true,
        "answer_header": [
            "Yes, you can download the product brochure from web page to understand the product details."
        ],
        "answer": [
            " You will receive the Web Link for proposal in SMS/Email/ WhatsApp",
            "Click the Web link and open it in the browser",
            "You will be able to see the Download Brochure link in the webpage under downloads.",
            "On opening the downloaded Brochure, you will be able to see product details and coverages."
        ]
    },
    {
        "question": "After Accepting the Proposal, how can I make Payment to complete the Policy Issuance Process?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            " Once you accept the proposal through OTP Consent, you will see option to make payment. Upon clicking on Make payment button, you will be directed to the PAYU Website. Once payment is successful you will be directed to your proposal page and you will get the message: 'Payment Successful'.   Your Policy document should be sent to you shortly."
        ]
    },
    {
        "question": "Can I request Liberty partner for making payment for my Policy?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            " Yes, once you accept the Proposal by giving the OTPConsent, you will get option to either make Payment or you can request to make Payment to Liberty Partner.You can click on ‘Request Agent for Payment’ Button and notification will be sent to Liberty Partner for the payment request.When agent will process the payment, you will receive the OTP on your mobile number, Agent will call you for OTP validation to process the payment further."
        ]
    },
    {
        "question": "Can I Download Policy Wordings Printed on my Policy Document?",
        "is_answer_multiple": true,
        "is_answer_header": true,
        "answer_header": [
            "Yes, you can download the policy wording from proposal web page which is accessible from email/SMS/WhatsApp so thatyou can read and learn about the policy being purchased.You can download the Policy wording to learn about policy being purchased using below steps:"
        ],
        "answer": [
            " Open the link received on Email/SMS/WhatsApp",
            "You will be able to see the Proposal details.",
            "You will get options to Download the Policy Wordings by simplyclicking on Download Policy Wording button.",
            "Policy wordings document will be based on the product for which proposal is create"
        ]
    },
    {
        "question": "Can I Regenerate the OTP for accepting the Proposal?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            " Yes, you can regenerate the OTP by clicking on ResendOTP button, you will receive the OTP ,you can enter the recently received OTP and accept the Proposal."
        ]
    },
    {
        "question": "Can I Change my communication details?",
        "is_answer_multiple": true,
        "is_answer_header": true,
        "answer_header": [
            "Yes, you can change your communication details,Follow the below Steps to do the same:"
        ],
        "answer": [
            " Click on web page link received for Proposal.",
            "Once Proposal Page is Opened, you will see Edit Button on Proposal Page",
            "By clicking on Edit Button you can edit the below information and Save it.1.Salutation 2.First Name 3.Middle Name 4.Last Name 5.Mobile Number 6.Email ID 7.Alternate mail ID 8.Alternate Mobile Number 9.Mailing Address"
        ]
    },
    {
        "question": "What is Endorsement?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            " Endorsement means the incorporation of changes / amendment /  revision /  alteration in the benefits, rates, age limit,Premium Due Date, Policy Expiry Date or changes in other termsand conditions in the Policy Document."
        ]
    },
    {
        "question": "What is Sum Insured?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            " It is the amount for which the property assured is initiallycovered under the policy. Sum assured amount is mentioned in the policy schedule attached to the policy documents. In certain unitlinked policies sum assured keeps growing annually through a feature called indexation."
        ]
    },
    {
        "question": "What are Policy documents? what do they consist of?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            " Policy document is the printed and signed insurance contract between the policy owner and LGI. Policy documents consist of the policy schedule, stamp duty page, standard policy conditions and supplementary contracts (if provided for in thepolicy)."
        ]
    }
]